import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, MenuItem, Select, Typography, Pagination, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Visibility } from "@mui/icons-material"; // Import the eye icon
import CMSPartnerDetailsModal from "./CMSPartnerDetailsModal";
import { makeStyles } from "@mui/styles";
import { PartnerArrowIcon } from "../../res/NewWebIcons";

const useStyles = makeStyles((theme) => ({
  evenRow: {
    backgroundColor: "#C1E0FB",
  },
  oddRow: {
    backgroundColor: "#FFFFFF",
  },
}));

const CMSPartners = () => {
  const classes = useStyles();
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem("jwtToken");
      try {
        const response = await axios.get(
          "https://api.ipaisa.co.in/myapp/admin/getAllMerchants",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              page: currentPage, // Pass currentPage as a query parameter
              size: pageSize,    // Pass pageSize as a query parameter
            },
          }
        );
        setPartners(response.data?.body?.data);
        setTotalRecords(response.data?.body?.totalElements || 0);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [currentPage, pageSize]);

  // Handle "View" button click
  const handleViewDetails = (partner) => {
    setSelectedPartner(partner);
    setOpenModal(true);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value - 1); // Pagination starts from 1, but API expects 0-based index
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(0); // Reset to the first page when page size changes
  };

  return (
    <Box sx={{ marginTop: "3%", padding: "2rem" }}>
      <Grid style={{ marginTop: "1%" }}>
        <Typography
          style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#343C6A",
          }}
        >
          CMS Partners
        </Typography>
      </Grid>

      <Grid sx={{marginTop:'2%'}}>
        <TableContainer component={Paper}
          sx={{
            maxWidth: "100%",
            overflowX: "auto",
            borderRadius: "12px 12px 0px 0px",
          }}>
          <Table>
            <TableHead style={{ backgroundColor: "#027BFE" }}>
              <TableRow>
                <TableCell sx={{ color: 'white' }}>Sr No.</TableCell>
                <TableCell sx={{ color: 'white' }}>Name</TableCell>
                <TableCell sx={{ color: 'white' }}>Phone</TableCell>
                <TableCell sx={{ color: 'white' }}>Email</TableCell>
                <TableCell sx={{ color: 'white' }}>Company</TableCell>
                <TableCell sx={{ color: 'white' }}>Admin Verification</TableCell>
                <TableCell sx={{ color: 'white' }}>Merchant ID</TableCell>
                <TableCell sx={{ color: 'white' }}>On Boarding Status</TableCell>
                <TableCell sx={{ color: 'white' }}>Mobile Verify Status</TableCell>
                <TableCell sx={{ color: 'white' }}>Kyc Status</TableCell>
                <TableCell sx={{ color: 'white' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {partners.map((partner, index) => (
                <TableRow key={partner.id}
                className={`${classes.tableRow} ${index % 2 === 0 ? classes.oddRow : classes.evenRow}`}>
                  <TableCell>{currentPage * pageSize + index + 1}</TableCell>
                  <TableCell>{`${partner.firstName} ${partner.lastName}`}</TableCell>
                  <TableCell>{partner.merchantPhoneNumber}</TableCell>
                  <TableCell>{partner.emailId}</TableCell>
                  <TableCell>{partner.companyLegalName}</TableCell>
                  <TableCell>{partner.adminVerification}</TableCell>
                  <TableCell>{partner.merchantLoginId}</TableCell>
                  <TableCell>{partner.onBoardingStatus}</TableCell>
                  <TableCell>{partner.mobileVerifyStatus}</TableCell>
                  <TableCell>{partner.kycStatus}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() => handleViewDetails(partner)}
                    >
                      <Visibility /> {/* Eye icon */}
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {/* Pagination */}
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        style={{ marginTop: "1%" }}
      >
        <Grid item>
          <Select
            variant="outlined"
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
          <Typography display="inline" style={{ marginLeft: 8 }}>
            Showing {currentPage * pageSize + 1} to{" "}
            {Math.min((currentPage + 1) * pageSize, totalRecords)} out of{" "}
            {totalRecords} records
          </Typography>
        </Grid>
        <Grid item>
          <Pagination
            count={Math.ceil(totalRecords / pageSize)}
            color="primary"
            page={currentPage + 1}
            onChange={handlePageChange}
          />
        </Grid>
      </Grid>

      {/* Modal for detailed view */}
      {selectedPartner && (
        <CMSPartnerDetailsModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          partner={selectedPartner}
        />
      )}
    </Box>
  );
};

export default CMSPartners;
